import { render } from "./ResearchOfficers.vue?vue&type=template&id=60e1d90a"
import script from "./ResearchOfficers.vue?vue&type=script&lang=js"
export * from "./ResearchOfficers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__